import React from 'react';
import AdminSidebar from '../components/AdminSidebar';
import '../styles/admin.css';

const AdminProducts = () => {
  return (
    <div className="admin-container">
      <AdminSidebar />
      <div className="admin-content">
        <div className="admin-header">
          <h1 className="admin-header-title">📦 Бүтээгдэхүүн Удирдах</h1>
        </div>

        <div className="admin-main">
          <div style={{ textAlign: 'center', padding: '40px', color: '#ddd' }}>
            <p style={{ fontSize: '18px', marginBottom: '15px' }}>⏳ Энэ хэсэг ирээдүйд хөгжүүлэх гэж байна</p>
            <p style={{ fontSize: '14px', color: '#999' }}>Бүтээгдэхүүн удирдах функцийн хөгжүүлэлт эхэлнэ</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdminProducts;

/*
// ORIGINAL CODE - COMMENTED OUT FOR FUTURE USE
import React, { useState, useEffect } from 'react';
import AdminSidebar from '../components/AdminSidebar';
import '../styles/admin.css';

const AdminProducts = () => {
  const [products, setProducts] = useState([]);
  const [showForm, setShowForm] = useState(false);
  const [editingId, setEditingId] = useState(null);
  const [formData, setFormData] = useState({
    name: '',
    category: '',
    description: '',
    price: '',
    image: '',
  });

  useEffect(() => {
    fetchProducts();
  }, []);

  const fetchProducts = async () => {
    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}/api/products`);
      const data = await response.json();
      setProducts(Array.isArray(data) ? data : []);
    } catch (error) {
      console.error('Error fetching products:', error);
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // Add product to list (in real app, would post to API)
    if (editingId) {
      setProducts(products.map((p) => (p.id === editingId ? { ...formData, id: editingId } : p)));
      setEditingId(null);
    } else {
      setProducts([...products, { ...formData, id: Date.now() }]);
    }
    setFormData({ name: '', category: '', description: '', price: '', image: '' });
    setShowForm(false);
  };

  const handleEdit = (product) => {
    setFormData(product);
    setEditingId(product.id);
    setShowForm(true);
  };

  const handleDelete = (id) => {
    if (window.confirm('Энэ бүтээгдэхүүнийг устгахдаа итгэлтэй байна уу?')) {
      setProducts(products.filter((p) => p.id !== id));
    }
  };

  return (
    <div className="admin-container">
      <AdminSidebar />
      <div className="admin-content">
        <div className="admin-header">
          <h1 className="admin-header-title">📦 Бүтээгдэхүүн Удирдах</h1>
          <button
            onClick={() => {
              setShowForm(!showForm);
              setEditingId(null);
              setFormData({ name: '', category: '', description: '', price: '', image: '' });
            }}
            className="admin-btn admin-btn-primary"
          >
            {showForm ? '❌ Цуцлах' : '➕ Шинэ Бүтээгдэхүүн'}
          </button>
        </div>

        <div className="admin-main">
          {showForm && (
            <form onSubmit={handleSubmit} className="admin-form">
              <h3 style={{ color: '#fff', marginBottom: '20px' }}>
                {editingId ? 'Бүтээгдэхүүн Засах' : 'Шинэ Бүтээгдэхүүн Нэмэх'}
              </h3>

              <div className="form-group">
                <label>Нэр</label>
                <input
                  type="text"
                  name="name"
                  value={formData.name}
                  onChange={handleInputChange}
                  required
                />
              </div>

              <div className="form-group">
                <label>Ангилал</label>
                <input
                  type="text"
                  name="category"
                  value={formData.category}
                  onChange={handleInputChange}
                  placeholder="e.g., Mining Equipment, Drilling Bit, Heavy Tires"
                  required
                />
              </div>

              <div className="form-group">
                <label>Тайлбар</label>
                <textarea
                  name="description"
                  value={formData.description}
                  onChange={handleInputChange}
                  required
                ></textarea>
              </div>

              <div className="form-group">
                <label>Үнэ</label>
                <input
                  type="number"
                  name="price"
                  value={formData.price}
                  onChange={handleInputChange}
                  required
                />
              </div>

              <div className="form-group">
                <label>Зургийн URL</label>
                <input
                  type="url"
                  name="image"
                  value={formData.image}
                  onChange={handleInputChange}
                  placeholder="https://example.com/image.jpg"
                />
              </div>

              <div className="admin-btn-group">
                <button type="submit" className="admin-btn admin-btn-success">
                  💾 Хадгалах
                </button>
                <button
                  type="button"
                  onClick={() => setShowForm(false)}
                  className="admin-btn admin-btn-secondary"
                >
                  ❌ Цуцлах
                </button>
              </div>
            </form>
          )}

          {products.length === 0 ? (
            <div style={{ textAlign: 'center', padding: '40px', color: '#ddd' }}>
              <p>Бүтээгдэхүүн олдсонгүй</p>
            </div>
          ) : (
            <table className="admin-table">
              <thead>
                <tr>
                  <th>Нэр</th>
                  <th>Ангилал</th>
                  <th>Үнэ</th>
                  <th>Үйлдэл</th>
                </tr>
              </thead>
              <tbody>
                {products.map((product) => (
                  <tr key={product.id}>
                    <td>{product.name}</td>
                    <td>{product.category}</td>
                    <td>₮{product.price}</td>
                    <td>
                      <div className="admin-btn-group">
                        <button
                          onClick={() => handleEdit(product)}
                          className="admin-btn admin-btn-secondary"
                          style={{ fontSize: '12px', padding: '6px 12px' }}
                        >
                          ✏️ Засах
                        </button>
                        <button
                          onClick={() => handleDelete(product.id)}
                          className="admin-btn admin-btn-danger"
                          style={{ fontSize: '12px', padding: '6px 12px' }}
                        >
                          🗑️ Устгах
                        </button>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>
      </div>
    </div>
  );
};

export default AdminProducts;
*/
